var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircleArrowUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2917 0C32.658 0 41.875 9.217 41.875 20.5833C41.875 31.9497 32.658 41.1667 21.2917 41.1667C9.92533 41.1667 0.708332 31.9497 0.708332 20.5833C0.708332 9.217 9.92533 0 21.2917 0Z",
    fill: "#4D6580"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0687 18.5428C23.6147 21.0888 26.1608 23.6374 28.7094 26.1834C30.9313 28.4079 34.3666 24.9467 32.1343 22.7144C29.0153 19.5954 25.8963 16.4764 22.7773 13.3574C21.831 12.4111 20.2624 12.4448 19.3342 13.373C16.2152 16.492 13.0936 19.6135 9.97462 22.7325C7.75268 24.9545 11.2113 28.3898 13.4436 26.1575C15.9896 23.6192 18.5279 21.081 21.0687 18.5428Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleArrowUp);
export default __webpack_public_path__ + "static/media/circle-arrow-up.cbd56d4a48322ff977cb094c12cf619f.svg";
export { ForwardRef as ReactComponent };